import { Component } from "react";

export class ErrorBoundaryProvider extends Component {
  state = { hasError: false, message: null };

  static getDerivedStateFromError(error) {
    console.log({ error });
    return { hasError: true, message: error.message };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100dvh",
            width: "100%",
            display: "grid",
            placeItems: "center",
          }}
        >
          <h1>
            {this.state.message ? this.state.message : "Something went wrong."}
          </h1>
        </div>
      );
    }
    return this.props.children;
  }
}
